import type { FC } from 'react';
import { useIsStagingOrDevOrLocal } from '@atlassian/jira-tenant-context-controller/src/components/environment/index.tsx';
import { pushSSRFailureDisplay } from './pushSSRFailureDisplay.tsx';
import type { SSRFailureProps } from './SSRFailureProps.types.tsx';

/**
 * A declarative component that taints a given location as a "fallback"
 * used to detect SSR success rate and the completeness of the page.
 */
export const FallbackIndicator: FC<SSRFailureProps> = ({
	reportToSlackChannel,
	fallbackId,
	displayErrorInStaging,
	isCookieCircuitBreakerFailure,
	cookieKey,
}) => {
	const isStagingOrDevOrLocal = useIsStagingOrDevOrLocal();
	if (__SERVER__) {
		if (displayErrorInStaging && isStagingOrDevOrLocal) {
			pushSSRFailureDisplay({
				reportToSlackChannel,
				fallbackId,
				displayErrorInStaging,
				isCookieCircuitBreakerFailure,
				cookieKey,
			});
		}
	}
	return null;
};

FallbackIndicator.displayName = 'FallbackIndicator';
